var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-breadcrumbs',{style:({ textDecoration: 'none', color: _vm.colors.BLACK }),attrs:{"items":_vm.data,"divider":"/"}})
}
var staticRenderFns = []

export { render, staticRenderFns }